import React from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { Mail, Linkedin, Github } from "lucide-react";

const fade = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" },
  }),
};

const pageTitleClass =
  "font-display text-3xl md:text-4xl font-semibold text-foreground border-l-2 border-accent pl-4";

export default function Contact() {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
      className="max-w-2xl mx-auto mt-10 md:mt-14 mb-16 px-4 md:px-6"
    >
      <Helmet>
        <title>Contact | Soham Desai</title>
        <meta name="description" content="Get in touch with Soham Desai for collaborations, research discussions, or consulting opportunities." />
      </Helmet>

      <motion.h1 variants={fade} custom={0} className={`${pageTitleClass} mb-8`}>
        Get in Touch
      </motion.h1>

      <motion.div variants={fade} custom={1} className="flex flex-wrap gap-5">
        <a
          href="mailto:soham.d.desai@gmail.com"
          className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent-hover transition-colors"
        >
          <Mail className="w-4 h-4" />
          soham.d.desai@gmail.com
        </a>
        <a
          href="https://www.linkedin.com/in/s-desai"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent-hover transition-colors"
        >
          <Linkedin className="w-4 h-4" />
          LinkedIn
        </a>
        <a
          href="https://github.com/soham12112"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent-hover transition-colors"
        >
          <Github className="w-4 h-4" />
          GitHub
        </a>
      </motion.div>
    </motion.div>
  );
}
